import React, { useContext, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLineChart } from '@fortawesome/free-solid-svg-icons';
import { Line } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const TrafficReferenceTimeSeriesCard = () => {
  const { data, isLoading } = useContext(DataContext);
  const [granularity, setGranularity] = useState('month'); // 'day' or 'month'

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  // Process the data based on selected granularity
  const processDate = (date) => {
    if (!date) { // This will catch both null and undefined
      return null;
    }
    return granularity === 'month'
      ? date.slice(0, 7) // yyyy-mm
      : date;            // yyyy-mm-dd
  };

  const trafficReferenceCounts = data.reduce((acc, item) => {
    const dateKey = processDate(item.dates_pedimento.created_pedimento_date);
    acc[dateKey] = (acc[dateKey] || new Set()).add(item.traffic_reference);
    return acc;
  }, {});

  // Convert Set to count
  for (const date in trafficReferenceCounts) {
    trafficReferenceCounts[date] = trafficReferenceCounts[date].size;
  }

  const chartData = {
    labels: Object.keys(trafficReferenceCounts).sort(),
    datasets: [
      {
        label: `Daily Traffic References (${granularity})`,
        data: Object.values(trafficReferenceCounts),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
      },
    ],
  };

  // Chart options
  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg flex flex-col justify-between h-custom-card-big overflow-y-auto">
      <div className="mb-4 flex justify-between items-center">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faLineChart} className="text-blue-600 mr-2" />
          Traffic Reference Time Series
        </h2>
        <select
          value={granularity}
          onChange={(e) => setGranularity(e.target.value)}
          className="border border-gray-300 rounded p-1"
        >
          <option value="day">Daily</option>
          <option value="month">Monthly</option>
        </select>
      </div>
      <div className="flex-grow relative h-full">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default TrafficReferenceTimeSeriesCard;